exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".myImg{width:600px}.modal-header .close{display:none}", ""]);

// exports
